import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getAuthData, clearAuthData, setAuthData } from "../services/api/authApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  if (process.env.REACT_APP_DEMO_MODE === "true" && !localStorage.getItem("authToken")) {
    localStorage.setItem("authToken", "offline-demo-token");
    localStorage.setItem("authUser", JSON.stringify({
      id: 1,
      firstName: "سپهر",
      lastName: "محمدی",
      phone: "09121234567",
    }));
  }
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const initializeAuth = useCallback(() => {
    const { token: storedToken, user: storedUser } = getAuthData();
    setToken(storedToken);
    setUser(storedUser);
    setLoading(false);
  }, []);

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  const login = useCallback((newToken, newUser) => {
    setToken(newToken);
    setUser(newUser);
    // Persist to localStorage for survival across refreshes/navigation
    setAuthData(newToken, newUser);
  }, []);

  const logout = useCallback(() => {
    clearAuthData();
    setToken(null);
    setUser(null);
  }, []);

  const value = {
    user,
    token,
    loading,
    isAuthenticated: !!token,
    login,
    logout,
    refreshAuth: initializeAuth,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export default AuthContext;
